import { newTrack } from '@/track'

export default {
  install(app: any) {
    // #region VUE errorHandler 和 React componentDidCatch
    app.config.errorHandler = (error: any, vm: any, info: any) => {
      console.error('Vue render error:', error, vm, info)
      const vmName = vm?.$options.name || vm?.$options.__file || ''
      newTrack('tech_page_error', {
        err_info: `Vue渲染错误: 组件为 ${vmName}, 位置为 ${info}, 错误信息为 ${error.message}`,
        err_type: 'vue_error',
        err_title: document.title,
        err_page: window.location.href,
      })
    }
    // #endregion

    if (typeof window === 'undefined')
      return

    // #region 全局监控 JS 异常
    window.onerror = function errorHandler(msg, url, lineNo, columnNo, error) {
      if (!error)
        return

      newTrack('tech_page_error', {
        err_info: `JS 异常: Message: ${msg}, Line: ${lineNo}, Column: ${columnNo}`,
        err_type: 'js_error',
        err_title: document.title,
        err_page: window.location.href,
        err_url: url,
      })
      return true
    }
    // #endregion

    // #region 全局监控静态资源异常
    window.addEventListener(
      'error',
      (event: any) => {
        if (event.target) {
          console.error(event)
          newTrack('tech_page_error', {
            err_info: '静态资源加载异常',
            err_type: 'load_error',
            err_title: document.title,
            err_page: window.location.href,
            err_url: event.target.currentSrc,
          })
        }
        return true
      },
      true,
    )
    // #endregion

    // #region 捕获没有 Catch 的 Promise 异常
    // window.addEventListener('unhandledrejection', (e) => {
    //   e.preventDefault()
    //   // 这个是 axios 抛出的错误, 在api的拦截器中上报, 不用重复上报
    //   if (e.reason.code && e.reason.msg)
    //     return

    //   newTrack('tech_page_error', {
    //     err_info: `捕获没有 Catch 的 Promise 异常: ${e.reason}`,
    //     err_type: 'unhandledrejection',
    //     err_title: document.title,
    //     err_page: window.location.href,
    //   })
    //   return true
    // })
    // #endregion
  },
}
